export const EP = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    me: '/auth/me',
    changePassword: '/auth/change-password',
  },
  iam: {
    users: '/iam/v1/users',
    roles: '/iam/v1/roles',
    permissions: '/iam/v1/permissions',
    apiTokens: '/iam/v1/api-tokens',
  },
  console: {
    overview: '/console/v1/overview',
    dataSources: '/console/v1/data-sources',
    datasetPaths: '/console/v1/dataset-paths',
    datasets: '/console/v1/datasets',
    fields: '/console/v1/fields',
    dataProducts: '/console/v1/data-products',
    dataProductEditor: '/console/v1/data-product-editor',
    builtinConnectors: '/console/v1/builtin-connectors',
    syncPolicies: '/console/v1/operations/sync-policies',
    acquisitionJobs: '/console/v1/operations/acquisition-jobs',
    dataProductPreview: '/console/v1/data-products/preview',
    currentRelease: '/console/v1/system/release/current',
    releases: '/console/v1/system/releases',
  },
  public: {
    dataProducts: '/v1/data-products',
    mcp: { tools: '/v1/mcp/tools', toolCalls: '/v1/mcp/tool-calls' },
  },
}
